import React, {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {useNavigate, useParams} from 'react-router-dom';

import {clearStrip} from 'src/components/criteria-strip';
import {SEARCH_RESULT_TABS} from 'src/constants';

import Tabs, {Tab} from '@pb/kit-component-tabs-v2';


type Props = {
    activeTab: string,
};

export const SearchCriteriaTabs = ({activeTab}: Props) => {
    const {searchId = ''} = useParams<{searchId?: string}>();

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const changeSearchTab = useCallback((tab: string) => {
        navigate(`/search-criteria/${searchId}/${tab}`);
        dispatch(clearStrip());
    }, [searchId, dispatch, navigate]);

    return (
        <Tabs style={{paddingLeft: 8}} value={activeTab} onChange={changeSearchTab}>
            <Tab caption="Search Accounts" value={SEARCH_RESULT_TABS.ACCOUNTS}/>
            <Tab caption="Search Users" value={SEARCH_RESULT_TABS.USERS}/>
        </Tabs>
    );
};
